import { createEffect, createSignal, type JSX, Show } from 'solid-js'

export function ShopOverlay(props: { open: boolean; children: JSX.Element }) {
  const [mounted, setMounted] = createSignal(false)
  const [entered, setEntered] = createSignal(false)

  createEffect(() => {
    if (props.open) {
      setMounted(true)
      // Double-RAF so the initial paint lands at translate-x-full before we
      // flip to translate-x-0. A single RAF is sometimes coalesced with the
      // first paint and skips the transition.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setEntered(true))
      })
    } else {
      setEntered(false)
    }
  })

  const handleTransitionEnd = (e: TransitionEvent) => {
    if (e.propertyName !== 'transform') return
    if (!props.open) setMounted(false)
  }

  return (
    <Show when={mounted()}>
      <div
        class="fixed inset-0 z-40 transition-transform duration-300 ease-out"
        classList={{
          'translate-x-0': entered(),
          'translate-x-full': !entered(),
        }}
        ontransitionend={handleTransitionEnd}
      >
        {props.children}
      </div>
    </Show>
  )
}
